import React, { Component } from 'react';
import AvatarEditor from 'react-avatar-editor'

class ImageCropper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			changes: false,
			scale: 10
		};

		// this.handleChange = this.handleChange.bind(this)
		this.handleCropChange = this.handleCropChange.bind(this)
		this.handleZoom = this.handleZoom.bind(this)
		this.setRef = this.setRef.bind(this)

		this.ae_ref = null
	}

	setRef(ae) {
		this.ae_ref = ae
	}

	handleCropChange() {
		let {prop} = this.props
		if (this.ae_ref != null) {
			let cropping_rect = this.ae_ref.getCroppingRect()
			let {x, y, width, height} = cropping_rect
			let crop_val = [x, y, width, height].join(',')
			this.props.cropChange(prop, crop_val)
		}
	}

	handleZoom(e) {
		this.setState({scale: e.currentTarget.valueAsNumber}, () => {
			this.handleCropChange()
		})
	}

	render() {
		let {image_data, prop, width, height, borderRadius} = this.props
		let {scale} = this.state
		let crop_val = ''
		if (this.ae_ref != null) {
			let cropping_rect = this.ae_ref.getCroppingRect()
			let {x, y, width, height} = cropping_rect
			crop_val = [x, y, width, height].join(',')
		}
		return (
              <div style={{marginBottom: '10px'}}>
	            <h4>Crop, resize &amp; pan image</h4>
                <AvatarEditor image={image_data}
                			  ref={this.setRef}
                			  width={width}
			                  height={height}
			                  borderRadius={borderRadius}
			                  scale={scale / 10}
			                  onMouseUp={this.handleCropChange}
                			  onImageChange={this.handleChange} />
				<input type="range" min="5" max="40" value={scale} className="slider" id="zoom" onChange={this.handleZoom} />
				<input type="hidden" name={`${prop}_crop`} value={crop_val} />
              </div>
        )
	}
}

ImageCropper.defaultProps = {
	width: 300,
	height: 300,
	borderRadius: 150
}

export default ImageCropper